import axios from "axios";
import authStore from "../stores/AuthStore";

class EventsAPIHandler {
  constructor() {
    this.api = axios.create({
      baseURL: process.env.REACT_APP_LOG_API_URL || "http://localhost:8001",
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });

    this.api.interceptors.request.use((config) => {
      const currentUser = authStore.getUser();
      const userID = currentUser?.id || currentUser?.userID;
      if (userID) {
        config.headers["X-User-ID"] = userID;
        if (config.method !== "get") {
          config.data = { userID, ...config.data };
        }
      }
      return config;
    });
  }

  async fetchEventsForDevice(deviceId, lastId = null) {
    try {
      const response = await this.api.post(`/events/deviceEvent/${deviceId}`, {
        last_id: lastId,
      });
      console.log("Fetch events for device response: ", response);
      return response.data;
    } catch (error) {
      console.error(
        `❌ Error fetching connection events for device id : ${deviceId}`,
        error
      );
      throw error;
    }
  }

  async fetchOverpressureEventsAll(lastId = null) {
    try {
      const response = await this.api.post("/events/overpressure/all", {
        params: lastId ? { last_id: lastId } : {},
      });
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching overpressure events for all:", error);
      throw error;
    }
  }

  async fetchOverpressureEventsForDevice(deviceId = null, lastId = null) {
    try {
      const response = await this.api.post(`/events/overpressure/${deviceId}`, {
        last_id: lastId,
      });
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching overpressure events:", error);
      throw error;
    }
  }

  async fetchOverpressureForDeviceSet(deviceIds = [], lastId = null) {
    try {
      const response = await this.api.post("/events/overpressure/by-devices", {
        device_ids: deviceIds,
        ...(lastId && { last_id: lastId }),
      });
      return response.data;
    } catch (error) {
      console.error(
        "❌ Error fetching overpressure events for device set:",
        error
      );
      throw error;
    }
  }
}

const eventsAPIHandler = new EventsAPIHandler();
export default eventsAPIHandler;
